import { CameraState, CameraAction } from "./types";

const initialState: CameraState = {
  currentStep: "permission",
  frontImage: null,
  sideImage: null,
  isLoading: true,
  isCapturing: false,
  showTimer: false,
  showOrientationGuide: false,
  timerCount: 0,
  hasPermission: null,
  permissionLoading: false,
  isOrientationCorrect: false,
  isOrientationSupported: false,
  captureMode: "manual", // Default to manual
  orientation: {
    beta: null,
    alpha: null,
    gamma: null,
  },
  cameraError: null,
  facingMode: "user",
  hasBackCamera: false,
  error: null,
};

const cameraReducer = (state: CameraState, action: CameraAction): CameraState => {
  switch (action.type) {
    case "SET_PERMISSION_LOADING":
      return { ...state, permissionLoading: action.payload };

    case "SET_PERMISSION":
      return {
        ...state,
        hasPermission: action.payload,
        permissionLoading: false,
        currentStep: action.payload === true || (action.payload === false && state.isOrientationSupported === false) ? "front" : "permission",
        isLoading: false,
      };

    case "FORCE_PERMISSION_STEP":
      return {
        ...state,
        currentStep: "permission",
        permissionLoading: false,
      };

    case "SET_ORIENTATION_SUPPORTED":
      return { ...state, isOrientationSupported: action.payload };

    case "SET_CAPTURE_MODE":
      return { ...state, captureMode: action.payload };

    case "SET_ORIENTATION":
      return { ...state, orientation: action.payload };

    case "SET_ORIENTATION_CORRECT":
      return {
        ...state,
        isOrientationCorrect: action.payload,
        showOrientationGuide: !action.payload,
      };

    case "SET_CAMERA_ERROR":
      return {
        ...state,
        cameraError: action.payload,
        isLoading: false,
        error: action.payload,
      };

    case "SET_LOADING":
      return { ...state, isLoading: action.payload };

    case "START_FRONT_CAPTURE":
      return {
        ...state,
        currentStep: "front",
        isCapturing: false,
        showOrientationGuide: false,
        error: null,
      };

    case "COMPLETE_FRONT_CAPTURE":
      return {
        ...state,
        frontImage: action.payload,
        currentStep: "side",
        isCapturing: false,
        showTimer: false,
        showOrientationGuide: true, // Reset to show guide for new step
      };

    case "START_SIDE_CAPTURE":
      return {
        ...state,
        currentStep: "side",
        isCapturing: false,
        showOrientationGuide: false,
      };

    case "COMPLETE_SIDE_CAPTURE":
      return {
        ...state,
        sideImage: action.payload,
        currentStep: "processing",
        isCapturing: false,
        showTimer: false,
        isOrientationCorrect: false,
        showOrientationGuide: false,
      };

    case "START_TIMER":
      return {
        ...state,
        showTimer: true,
        timerCount: action.payload,
        isCapturing: true,
      };

    case "UPDATE_TIMER":
      return { ...state, timerCount: action.payload };

    case "STOP_TIMER":
      return {
        ...state,
        showTimer: false,
        timerCount: 0,
      };

    case "TOGGLE_CAMERA":
      return {
        ...state,
        facingMode: state.facingMode === "user" ? "environment" : "user",
      };

    case "SET_HAS_BACK_CAMERA":
      return { ...state, hasBackCamera: action.payload };

    case "SET_ERROR":
      return {
        ...state,
        error: action.payload,
        isLoading: false,
        isCapturing: false,
        showTimer: false,
      };

    case "RESET":
      return initialState;

    default:
      return state;
  }
};

export { initialState, cameraReducer };
